import { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import type { UUID } from "@/core/types";

import { CreateAddendum } from "./(form)/CreateAddendum";

type AddNoteAddendumProps = {
  credentials: string | undefined;
  noteId: UUID;
  patientId: UUID;
  signature: string | undefined;
};

export function AddNoteAddendum({
  credentials,
  noteId,
  patientId,
  signature,
}: AddNoteAddendumProps) {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <DashboardCard2
      Actions={
        !isEditMode && (
          <Button2
            onPress={() => setIsEditMode(true)}
            variant="link"
            {...getAutomationDataAttr("note-addendum-link")}
          >
            Add Addendum
          </Button2>
        )
      }
      className={cn(!isEditMode && "tw:pb-0!")}
      classNameChildren="tw:flex tw:w-full"
      classNameHeader={cn(!isEditMode && "tw:mb-0!")}
      copy="Add details to an existing note."
      rawChildren
      title="Addendum"
    >
      {isEditMode && (
        <CreateAddendum
          credentials={credentials}
          noteId={noteId}
          onCancel={() => setIsEditMode(false)}
          onSuccess={() => setIsEditMode(false)}
          patientId={patientId}
          signature={signature}
        />
      )}
    </DashboardCard2>
  );
}
